<form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
  <div *ngFor="let field of formFields" class="mb-3">

    <ng-container [ngSwitch]="field.type">
      <input *ngSwitchCase="'text'" [id]="field.label" [formControlName]="field.label" class="form-control" type="text"
        [placeholder]="field.label + (field.required ? ' *' : '')" />

      <input *ngSwitchCase="'email'" [id]="field.label" [formControlName]="field.label" class="form-control"
        type="email" [placeholder]="field.label + (field.required ? ' *' : '')" />

      <textarea *ngSwitchCase="'textarea'" [id]="field.label" [formControlName]="field.label" class="form-control"
        rows="5" [placeholder]="field.label + (field.required ? ' *' : '')"></textarea>

      <div *ngSwitchCase="'radiobutton'" class="radio-group">
        <label class="form-label" *ngIf="field?.label">{{ field.label }}{{ field.required ? ' *' : '' }}</label>
        <div class="radio-options">
          <span *ngFor="let option of field.radioButtons">
            <input 
              [id]="field.label + '_' + option.label"
              [attr.name]="field.label + 'radio'"
              [formControlName]="field.label" 
              class="form-check-input me-2" 
              type="radio" 
              [value]="option.label">
            <label [for]="field.label + '_' + option.label" class="form-check-label me-4">
              {{ option.label }}
            </label>
          </span>
        </div>
      </div>
    </ng-container>

    <!-- Validatie melding -->
    <div *ngIf="formGroup.get(field.label)?.touched && formGroup.get(field.label)?.invalid" class="text-danger ">
      <small *ngIf="formGroup.get(field.label)?.errors?.['required']">Dit veld is verplicht.</small>
      <small *ngIf="formGroup.get(field.label)?.errors?.['email']">Voer een geldig e-mailadres in.</small>
    </div>
  </div>

  <div class="text-center mt-5">
    <button type="submit" class="btn btn-light" *ngIf="!loading">{{ submitButtonText }} <i
                class="fa-duotone fa-solid fa-circle-arrow-right fa-duotone-custom-colors"
              ></i
            ></button>
            <i class="fas fa-spinner fa-spin" *ngIf="loading"></i>
  </div>
</form>
